import { render, staticRenderFns } from "./magiclinkAuth.vue?vue&type=template&id=3386624b"
import script from "./magiclinkAuth.vue?vue&type=script&lang=js"
export * from "./magiclinkAuth.vue?vue&type=script&lang=js"
import style0 from "./magiclinkAuth.vue?vue&type=style&index=0&id=3386624b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports